module.exports = __webpack_public_path__ + "media/partners/loreal-eec73b05.svg";